<template>
    <div class="contact-picker">
        <ui-select
            :icon="icon"
            :disabled="disabled"
            disable-filter
            has-search
            :disable-filter="true"
            :label="label"
            :placeholder="placeholder"
            search-placeholder="Start typing to search"
            :keys="{ label:'primary_display_as', value: 'id' }"

            :loading="isLoading"
            :no-results="noResults"
            :options="options"

            @query-change="doFind"
            @change="contactChanged"
            v-model="selected"
            :class="controlClass"
            :help="helpText"
        >
            <slot>{{ label ?? '' }}</slot>
            <template v-slot:option="slot">
                <contact-select-option :contact="slot.option"></contact-select-option>
            </template>
        </ui-select>
        <div style="margin-top: auto;">
            <button :disabled="disabled" v-if="canCreate" class="btn btn-success btn-sm" @click="newContact">
                <i class="material-icons" style="vertical-align: middle;">add</i>
            </button>
        </div>
        <a v-if="canClear && !isEmpty" href="#" @click.prevent="clear" style="font-size: .8rem; margin-bottom: 1rem; display: inline-block;">Clear Contact</a>

        <contact-modal v-if="canCreate" ref="editModal" @success="contactChanged"></contact-modal>
    </div>
</template>

<style lang="scss">
    .contact-picker {
        display: flex;
        margin-bottom: 1rem;

        .select-control {
            flex:1;
            margin-bottom: 0;
        }

        .btn {
            margin-left: 1rem;
        }
    }
</style>

<script>
    import ContactModal from '../ContactModal'
    import _ from 'lodash';
    import SearchesContacts from './SearchesContacts'
    import {ContactTypeList} from "../../../classes/Api/Contact";
    import ContactSelectOption from "./ContactSelectOption.vue";
    
    export default {
        components: {ContactSelectOption, ContactModal },
        mixins: [SearchesContacts],
        props: {
            placeholder: {
                type: String,
                default: 'Select contact'
            },
            label: {
                type: String,
            },
            value: {
                type: Object,
            },
            canCreate: {
                type: Boolean,
                default: true,
            },
            canClear: {
                type: Boolean,
                default: false,
            },
            type: {
                default: null,
            },
            icon: {
                type: String,
                default: ''
            },
            newContactDefaults: {
                type: Object,
                default() {
                    return {}
                }
            },
            disabled: {
                default: false
            },
            relationsToLoad: {
                type: Array,
                default() {
                    return []
                }
            },
            showAccountCode: {
                type: Boolean,
                default: false
            }
        },
        created() {
            if (this.value) {
                this.selected = this.value;
            }
        },
        data() {
            return {
                selected: {},
            }
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    if (!n) {
                        n = {};
                    }

                    this.selected = n;
                }
            }
        },
        computed: {
            isEmpty() {
                return _.isEmpty(this.selected);
            },
            helpText() {
                if (this.showAccountCode && this.selected && this.selected.sage_reference) {
                    return `Sage Account Code: ${this.selected.sage_reference.ref}`
                }

                return ''
            },
            controlClass() {
                let str = 'select-control';

                if (this.canCreate) {
                    str += ' addable';
                }

                if (this.canClear && !this.isEmpty) {
                    str += ' emptyable'
                }

                return str;
            }
        },
        methods: {
            doFind(query) {
                    this.onQueryChange(query);
            },
            newContact() {
                let defaults = this.newContactDefaults

                if (this.type) {
                    defaults.type = ContactTypeList.find(item => {
                        return item.value === this.type
                    })
                }

                this.$refs['editModal'].open(defaults);
            },
            contactChanged(val) {
                this.$emit('input', val);
            },
            clear() {
                this.selected = {};
                this.contactChanged({});
            }
        }
    }
</script>